/* Collar: filterikon i stället för sidofiltret på desktop (snippets/collar-filterikon.liquid).
   Temats JS (Filters i theme.js) öppnar filterlådan bara under 768 px. Här öppnas samma låda från 768 px och uppåt.
   Stängning sköter temat själv (krysset, "Visa mina resultat", Esc), plus klick utanför lådan här.
   Körs efter temats klickhanterare (lyssnar på document), så temat hinner sätta fokusfällan först. */
(function () {
  var DESKTOP = 768;
  var VISIBLE = 'collection__filters--visible';
  var SECTION = '[data-section-type="collection-template"][data-enable-filters="true"]';

  function isDesktop() {
    return window.innerWidth >= DESKTOP;
  }

  document.addEventListener('click', function (event) {
    if (!isDesktop()) return;

    var toggle = event.target.closest('[data-toggle-filters]');
    if (toggle) {
      var section = toggle.closest(SECTION);
      var filters = section && section.querySelector('[data-collection-filters]');
      if (!filters || filters.classList.contains(VISIBLE)) return;

      filters.classList.add(VISIBLE);
      document.dispatchEvent(
        new CustomEvent('theme:scroll:lock', {
          bubbles: true,
          detail: filters.querySelector('[data-collection-filters-list]'),
        })
      );
      return;
    }

    // Klick utanför den öppna lådan (på den mörka bakgrunden): stäng med temats egen stängknapp.
    var open = document.querySelector(SECTION + ' .' + VISIBLE);
    if (open && !open.contains(event.target)) {
      event.preventDefault();
      var close = open.querySelector('[data-close-filters]');
      if (close) close.click();
    }
  });
})();
